import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCarousel from "vue-carousel";

import "./assets/icomoon/style.css";
import "./assets/scss/app.scss";
import "moment/locale/pt-br";
import "./components";
import "./plugins";
import { init } from "./setup/api";
import CKEditor from "@ckeditor/ckeditor5-vue2";

Vue.use(BootstrapVue);
Vue.use(CKEditor);
Vue.use(VueCarousel);

init();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

window.openSupport = function() {
  const iframes = window.document.getElementsByTagName("iframe");
  for (let i in iframes) {
    const button = iframes[i].contentDocument
      ? iframes[i].contentDocument.getElementsByClassName("u-isActionable")
      : false;
    if (button && button.length) {
      button[0].click();
    }
  }
};

const TODO_STORAGE_KEY = "todostorage";

let todoStorage = {
  fetch: () => JSON.parse(localStorage.getItem(TODO_STORAGE_KEY) || "[]"),
  save: todos => localStorage.setItem(TODO_STORAGE_KEY, JSON.stringify(todos))
};
